import { RouteConfig } from 'vue-router';
import { ifAuthenticated } from '../routeValidation';
import AuthenticationLayout from '@/views/Layout/landingLayout.vue';
import Landing from '@/views/landing/Landing.vue';
import { ROUTES } from './routes';

const { LANDING, } = ROUTES;

const landingRoute: RouteConfig = {
  path: '/Landing',
  component: AuthenticationLayout,
  beforeEnter: ifAuthenticated,
  children: [
    {
      path: LANDING.route,
      name: LANDING.name,
      component: Landing,
    }
  ],
};
export default landingRoute;
